<template>
  <div style="height:100%;display: flex;flex-direction: column;justify-content: center;">
    <p style="text-align: center;font-size: 36px;">金桥Saas云平台超管系统</p>
    <p style="text-align: center;font-size: 16px;">Supported By Gansu JinQiao Software Co.,Ltd</p>
  </div>
</template>

<script>
// @ is an alias to /src
import AuthService from "@/service/AuthService";
export default {
  name: 'Home',
  data(){
    return {
      current: null
    };
  },
  created() {
    // AuthService.current().then(d=>{
    //   this.current = d;
    // }).catch(e=> {
    //   this.$router.push({path: '/login'});
    // })
  }
}
</script>
